import { Outlet } from 'react-router-dom';
import './PortalLayout.css';

function PortalLayout() {
  return (
    <div className="portal-layout">
      <main className="portal-layout__main">
        <Outlet />
      </main>
    </div>
  );
}

export default PortalLayout;
